import React from 'react';
import { Link } from 'react-router-dom';
import Dotdotdot from 'react-dotdotdot';
import PropTypes from 'prop-types';

import BackgroundImage from '../../BackgroundImage';

import styles from './CollegeHSClubCard.scss';

const CollegeHSClubCard = (props) => {
    const { onClick, checkGate, featureGates, isPowerUser, 'data-testid': dataTestId } = props;
    const { id, name, school, location, isCollege, isHighSchool, clubProfileImages, activeRoster } = props.club;
    const locationValue = location?.display ? location.display : '';
    let clubPath = 'clubs';
    let defaultImage = '/img/v2/icons/icon-avatar-club.svg';
    if (isCollege) {
        clubPath = 'colleges';
        defaultImage = '/img/v2/icons/icon-avatar-college.svg';
    } else if (isHighSchool) {
        clubPath = 'schools';
        defaultImage = '/img/v2/icons/icon-avatar-school.svg';
    }
    const redirectUrl = `/${clubPath}/${id}`;

    // Check feature gate to determine which power6 value to use
    const isRostersRolloutEnabled = checkGate && featureGates ? checkGate(featureGates.ROSTERS_ROLLOUT) : false;
    const power6Value = isRostersRolloutEnabled
        ? (activeRoster?.power6?.power6Rating ?? null)
        : (school?.power6 ?? null);
    return (
        <Link to={redirectUrl} onClick={onClick} data-testid={dataTestId && `${dataTestId}.card-link`}>
            <div className={`mb16 division-card clickable`}>
                <div className="details row no-gutters">
                    <div className={`h6 col-8`}>
                        <div data-testid={dataTestId && `${dataTestId}.name`}>
                            <Dotdotdot clamp={2}>{name}</Dotdotdot>
                        </div>
                        <div className={`${styles.place}`} data-testid={dataTestId && `${dataTestId}.place`}>
                            {locationValue || ''}
                        </div>
                    </div>
                    <div className="col-4">
                        <div className={`${styles.flexContainer}`}>
                            <div className={`${styles.flexColumn} ${styles.pictureContainer}`}>
                                <BackgroundImage
                                    baseUrl={'/v1/club/'}
                                    defaultImage={defaultImage}
                                    images={clubProfileImages}
                                    imageType={'profile'}
                                    parentStylesClass={styles.profilePicture}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.devider}`} />
                <div className={`${styles.footer}`}>
                    <div className="row">
                        {isPowerUser && power6Value !== null && power6Value >= 0 && (
                            <div className="col-3">
                                <div className={`${styles.title}`} data-testid={dataTestId && `${dataTestId}.power6-title`}>Power 6</div>
                                <div className={`${styles.value}`} data-testid={dataTestId && `${dataTestId}.power6-value`}>{power6Value ? power6Value.toFixed(2) : '--'}</div>
                            </div>
                        )}
                        {/* <div className="col-3">
                                <div className={`${styles.title}`}>Roster</div>
                                <div className={`${styles.value}`}>{school.rosterCount ? school.rosterCount : '--'}</div>
                            </div> */}
                        {(isCollege && school?.conference?.division?.shortName) && (
                            <div className="col-3">
                                <div className={`${styles.title}`} data-testid={dataTestId && `${dataTestId}.division-title`}>Division</div>
                                <div className={`${styles.value}`} data-testid={dataTestId && `${dataTestId}.division-value`}>{school.conference?.division?.shortName ? school.conference.division.shortName : '--'}</div>
                            </div>
                        )}
                        {(isCollege && school?.conference?.shortName) && (
                            <div className="col-3">
                                <div className={`${styles.title}`} data-testid={dataTestId && `${dataTestId}.league-title`}>League</div>
                                <div className={`${styles.value}`} data-testid={dataTestId && `${dataTestId}.league-value`}>{school.conference?.shortName ? school.conference.shortName : '--'}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Link>
    );
};

CollegeHSClubCard.propTypes = {
    club: PropTypes.objectOf(PropTypes.any).isRequired,
    onClick: PropTypes.func,
    checkGate: PropTypes.func,
    featureGates: PropTypes.shape({
        ROSTERS_ROLLOUT: PropTypes.string,
    }),
    isPowerUser: PropTypes.bool,
};

CollegeHSClubCard.defaultProps = {
    onClick: null,
    checkGate: null,
    featureGates: {},
    isPowerUser: false,
    'data-testid': null,
};

export default CollegeHSClubCard;
